import { apiGet, apiPostBlob } from './client';

export type AssessmentStatus = 'available' | 'conditional' | 'unlikely' | 'unknown';

export type DesignationTrafficLight = 'green' | 'yellow' | 'red' | 'unknown';

export type TextualVerdict = 'yes' | 'no' | 'conditional' | 'unknown';

export type AssessmentResponse = {
  status: AssessmentStatus;
  verdict: TextualVerdict;
  traffic_light: DesignationTrafficLight;
  summary_he: string;
  designation_matched?: string | null;
  engine_version?: string;
  computed_at?: string;
};

export type PlanningInfoFetchStatus = 'complete' | 'partial' | 'failed';

export type PlanningField = {
  label: string;
  value: string;
  /** Link to תקנון PDF page (FR-I18). */
  href?: string;
  confidence?: number;
  verified?: boolean;
};

export type PlanningSection = {
  title: string;
  fields?: PlanningField[];
  columns?: string[];
  rows?: string[][];
  items?: PlanningField[];
  notes?: string[];
};

export type PlanningSectionsJson = {
  section1?: PlanningSection;
  section2?: PlanningSection;
  section3?: PlanningSection;
  section4?: PlanningSection;
};

export type PlanningInfoResponse = {
  migrash?: string;
  gush?: number;
  helka?: number;
  source?: string;
  fetch_status: PlanningInfoFetchStatus;
  sections_json: PlanningSectionsJson;
  fetched_at?: string;
};

export function fetchAssessment(sessionId: string): Promise<AssessmentResponse> {
  return apiGet<AssessmentResponse>(`/api/sessions/${sessionId}/assessment`);
}

export function fetchPlanningInfo(
  sessionId: string,
  options?: { extractTakanon?: boolean },
): Promise<PlanningInfoResponse> {
  const params = new URLSearchParams();
  if (options?.extractTakanon) {
    params.set('extract_takanon', 'true');
  }
  const query = params.toString();
  const path = `/api/sessions/${sessionId}/planning-info${query ? `?${query}` : ''}`;
  return apiGet<PlanningInfoResponse>(path);
}

export type PlanningReportPdfRequest = {
  /** Omit to use /planning-info/print/:sessionId (recommended) */
  html?: string;
  baseUrl?: string;
  /** UI language for print route (?lang=) */
  lang?: 'he' | 'en' | 'ar' | 'ru';
};

export function fetchPlanningReportPdf(
  sessionId: string,
  body: PlanningReportPdfRequest,
): Promise<Blob> {
  return apiPostBlob(`/api/sessions/${sessionId}/planning-info/pdf`, body);
}
